<template>
  <div id="thirdPart">
    <div class="titlePart">
      <h2 class="title">南京动车段</h2>
      <div class="intro">
          南京动车段负责江苏、安徽地区高铁、动车日常检查、养护、维修工作，下辖南京动车运用所、南京南动车运用所、合肥南动车运用所、徐州东
      </div>
    </div>
    <div class="casebutlist">
      <div
        class="caseButton wow animate__zoomIn"
        v-for="(item, index) in list.slice(0, 5)"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <div class="casebutlist">
      <div
        class="caseButton wow animate__zoomIn"
        v-for="(item, index) in list.slice(5, 10)"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <div class="imgBox">
      <Viewer :srcArr="srcListArr" />
    </div>

    <div class="bottomRow">
      <div
        class="countPanel wow animate__zoomIn"
        v-for="(item, index) in bottomPanelData"
        :key="index"
      >
        <div class="panelCount">{{ item.count }}</div>
        <div class="panelTitle">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Viewer from "../viewer/viewer.vue";
import { WOW } from "wowjs";
export default {
  props: {},
  data() {
    return {
      list: [
        "火灾自动报警",
        "电气火灾系统",
        "水系统",
        "消防电源系统",
        "视频系统",
        "视频烟火分析系统",
        "充电桩检测监控",
        "道闸系统",
        "门禁系统",
        "安防周界监控系统",
      ],
      srcListArr: [
        {
          src: require("../../assets/img/case/2.jpg"),
          name: "",
        },
        {
          src: require("../../assets/img/case/3.png"),
          name: "",
        },
      ],
      bottomPanelData: [
        { count: "6+", desc: "下属单位" },
        { count: "6000+", desc: "消防点位" },
        { count: "100+", desc: "视频" },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {
    new WOW({ live: false }).init();
  },
  watch: {},
  methods: {},
  components: {
    Viewer,
  },
};
</script>

<style scoped lang="scss">
#thirdPart {
  padding: 5% 14%;
  .titlePart {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 3rem;
    .title {
      font-size: 2.6rem;
      line-height: 4.2rem;
      margin-bottom: 1rem;
    }
    .line {
      width: 13rem;
      border-bottom: 0.2rem solid #535353;
      margin: 2rem 0 1.4rem;
    }
    .intro {
      width: 70%;
      color: #999999;
      text-align: justify;
      text-justify: inter-ideograph; /*IE*/
      font-size: 1.4rem;
      line-height: 2.2rem;
    }
  }
  .casebutlist {
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 18%;
    margin: 2rem 0;
    .caseButton {
      background: #ffffff;
      color: #00a087;
      padding: 0.5rem 3rem;
      border-radius: 24px;
      font-size: 1.4rem;
      font-weight: bold;
      letter-spacing: 0.15rem;
      margin: 1rem;
      box-shadow: 0px 5px 32px 0px rgba(202, 202, 202, 0.34);
      cursor: pointer;
    }
  }
  .imgBox {
    margin-bottom: 5rem;
    .elRow {
      display: flex;
      flex-wrap: wrap;
    }
    .innerBox {
      position: relative;
      margin-top: 3rem;
      width: 100%;
      height: 30rem;
      display: flex;
      justify-content: space-between;
      .el-image {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
      .bigEye {
        position: absolute;
        bottom: 0rem;
        right: 0rem;
        cursor: pointer;
        background: #18b09b;
        width: 3rem;
        height: 3rem;
        border-radius: 0 0 4px 0;
      }
    }
  }
  .bottomRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    .countPanel {
      background: #ffffff;
      box-shadow: 0px 7px 70px 0px rgba(201, 217, 222, 0.39);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      width: 32%;
      height: 12rem;
      &:hover {
          background: linear-gradient(125deg, #00B7A4, #0DCA81);
        box-shadow: 0px 1rem 2rem 0px rgba(48, 55, 66, 0.15);
        transform: translate(0, -5px);
        transition: all 0.3s;
        .panelCount {
            color: #ffffff;
        }
        .panelTitle {
            color: #ffffff;
        }
      }
      .panelCount {
        font-weight: bold;
        color: #333333;
        line-height: 2.4rem;
        font-size: 2.4rem;
      }
      .panelTitle {
        color: #999999;
        line-height: 2.4rem;
        font-size: 1.4rem;
        margin-top: 2rem;
        &:hover {
            color: #ffffff;
        }
      }
    }
    .activePanel {
      background: linear-gradient(125deg, #00b7a4, #0dca81);
      box-shadow: 0px 5px 32px 0px rgba(47, 189, 141, 0.34);
      .panelCount,
      .panelTitle {
        color: #ffffff !important;
      }
    }
  }

  /deep/.el-dialog {
    background: none;
    box-shadow: none;
  }
  /deep/.el-dialog__body {
    text-align: center;
  }
  /deep/ .el-dialog__title {
    display: none;
  }
}
@import "../../assets/responsive/case.scss";
</style>
